// Syft ACP - Atoms <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'
import BaseIcon from './base/BaseIcon'

const CheckIcon = ({ fill }) => <BaseIcon fill={fill} iconSlug="check" iconAlt="Checkmark" />

export default CheckIcon
